import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto py-6">
      <div className="flex items-center justify-center gap-3 text-xs text-muted-foreground/50">
        <span>© {new Date().getFullYear()} Livon®</span>
        <span>·</span>
        <a href="mailto:support@livon.se" className="hover:text-primary transition-colors">support@livon.se</a>
      </div>
    </footer>
  );
}
